module.exports = __webpack_public_path__ + "img/copertina_insegnante.6cc7112b.jpg";